export const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const emailPatternMain =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;

export const passwordPattern = new RegExp(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/);
export const passwordPatternOld = new RegExp(/^(?=.*[a-z])(?=.*\d)[a-zA-Z\d]{8,}$/);

// IOS Password Pattern ((?=.*\\d)(?=.*[a-zA-Z]).{8,})
